export default "__VITE_ASSET__dc9b8ab8__"